// What Support hands the platform shell (spec, The module contract: The entry).
import { SECTIONS } from '../layout/nav-items.js';
import { supportRoutes } from '../App.jsx';
import { SupportHeaderActions } from '../layout/AppLayout.jsx';
import { DraftsProvider } from '../components/drafts/DraftsProvider.jsx';
import DraftTabs from '../components/drafts/DraftTabs.jsx';
import TeamDraftsLink from '../components/drafts/TeamDraftsLink.jsx';

export default {
  // SECTIONS carries {product, role}; the contract's `requires` is the rank within THIS
  // module's product, so the product is dropped (every Support section is 'support').
  nav: SECTIONS.map(({ to, label, requires }) => ({
    to, label, requires: requires === null ? null : { role: requires.role },
  })),
  // Relative to /support; the shell mounts them at `/support/*`.
  routes: supportRoutes,
  // Wraps the header slots (portalled into the shell's header), tab row AND page: the row draws the drafts, and the create screen in
  // the page reports each draft's save state to it (the Support session's requirement).
  Provider: DraftsProvider,
  // Not a SECTION: it is a page under /tickets, and nav-items.js's list also
  // feeds the feature-request form's areas. Renders nothing below lead rank.
  HeaderNavExtras: TeamDraftsLink,
  HeaderActions: SupportHeaderActions,
  // Under the header (after the platform's bands), inside DraftsProvider.
  BelowHeader: DraftTabs,
};
